import React, { Component } from "react";
import Mapautocomplete from "./Mapautocomplete";

import axios from 'axios'; 
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';


import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MyLocation from '@mui/icons-material/MyLocation';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import TextField from '@mui/material/TextField';

const mapStyles = {
  width: '100%',
  height: '400px'
};

  class  Location extends Component {
	 constructor(props) {
      super(props)
	  
	  this.state = {locopen:true,sellat:'',zoom:10,sellong:'',or_address:"",lat:"",lng:"",latitude:"", longitude:'',errormessage:'',errorpen:false,addrsdata:[], buildingno:'',editbuilding:0,adid:0,branchid:'',
	 
	  markers: [
        {
          title: "The marker`s title will appear as a tooltip.",
          name: "SOMA",
          position: { lat: 	12.971599, lng: 77.594566 }
        }
      ]}
	   this.onClick = this.onClick.bind(this); 
	 }
	 componentWillMount() {
		 this.Myaddresslist();
	 setTimeout(
  () => 	 this.Getgooglemap(), 
  3000
); 
	 }  
	  handleClose = (e) => {
	 this.setState({locopen:!this.state.locopen,  
	  });
}
	
	handlecloseError=(event)=>{
	  
	this.setState({errorpen: false});  
  }
  
  Myaddresslist(){
	  
	axios.post(Serverurl+'ajaxaddress.php?action=getall&ad_cs_id='+this.props.custid)
  .then(resp => {
		if(resp.data.length>0){
			
			this.setState({addrsdata:resp.data,});
	    }else{
			this.setState({addrsdata:[]});
		}
    });
	  
  }
Onclicklocationsave= (event) => {
 let self=this;
 
 if(this.state.sellat==="")
 {
	this.setState({errormessage:"Please select your location",errorpen:true});
		 window.scrollTo({top: 0 }) 
		 return true;
 }
  var formData = new FormData();
	 formData.append('action','verifylocation')
	  formData.append('lat',this.state.sellat)
	  formData.append('long',this.state.sellong)
axios.post(Serverurl+"ajaxbranch.php", formData, {
				}).then(res => {
					
					if(res.data===-1)
					{
						this.setState({errormessage:"Your location is out of limit",errorpen:true});
		 window.scrollTo({top: 0 })
					}else{
						this.setState({branchid:res.data});
						
						  var formData1 = new FormData();
						  formData1.append('action','insertupdate')
						  formData1.append('ad_id',self.state.adid) 
						  
						  formData1.append('ad_address',self.state.or_address)
						 formData1.append('ad_latitude',self.state.sellat)
						formData1.append('ad_longitude',self.state.sellong)
						formData1.append('ad_buildingdetails',self.state.buildingno)
							formData1.append('ad_cs_id',this.props.custid)
						formData1.append('userid',localStorage.getItem("AYLuserid"))
						axios.post(Serverurl+"ajaxaddress.php", formData1, {
				}).then(res => {
					self.props.parentcallAddress(
					self.state.sellat+"~"+self.state.sellong+"~"+self.state.buildingno+"-"+self.state.or_address+"~"+self.state.branchid
					);
						this.setState({locopen:!this.state.locopen,});
				});
						
						
					}
					
				});
	
	
}
	  Getgooglemap(){
	   let self=this;
	   
	   if(this.state.latitude==="")
	   {
	   if ("geolocation" in navigator) {
       navigator.geolocation.getCurrentPosition(function(position) {
	
	  self.setState({latitude:position.coords.latitude,longitude:position.coords.longitude,loading:'',
	  
	   markers: [
        {
          
          position: { lat:position.coords.latitude, lng: position.coords.longitude }
        } ]
	  });
	  
	   
    });
    }
	   } 
   }
Onclickgetlocation(lat,lng,building,adrs,adid){
	
this.setState({sellat:lat,errorpen:false,sellong:lng,or_address:adrs,adid:adid,buildingno:building}); 
						
	 
}
   onMarkerClick = (props, marker, e) =>{
 
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
	}
	onClose = props => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  };
    onMapClicked = (props) => {
		
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };
   onClick(t, map, coord) {
	   var self=this;
    const { latLng } = coord;

    const lat = latLng.lat();
    const lng = latLng.lng();
	
	let formatadrs="";
	// var latlng = new window.google.maps.LatLng(parseFloat( lat), parseFloat(lng));
	var geocoder =  new window.google.maps.Geocoder();
 
            var address;
            geocoder.geocode({ 'latLng': latLng}, function (results, status) {
                
                    if (status === "OK") {             
                       
formatadrs=results[0].formatted_address;
              self.setState({buildingno:'',errorpen:false,sellat:lat,sellong:lng,or_address:formatadrs}); 

/*self.props.parentcalladdress(
lat+"~"+lng+"~"+formatadrs
);	*/		  
                }
            });
 
    this.setState(previousState => {
      return {
        markers: [
        
          {
            title: "",
            name: "",
            position: { lat, lng }
          }
        ]
      };
    });
	
  }
   handleCallback = (childData) => {
         let self=this;
	var strvalues=childData.split('~');
	const lat = strvalues[0];
    const lng = strvalues[1];
	
	/*self.props.parentcalladdress(
strvalues[0]+"~"+strvalues[1]+"~"+strvalues[2]
);*/
	
	 this.setState({sellat:strvalues[0],buildingno:'',errorpen:false,sellong:strvalues[1],zoom:14,latitude:lat,longitude:lng,or_address:strvalues[2]});
    this.setState(previousState => {
      return {
        markers: [
        
          {
            title: "",
            name: "",
            position: { lat, lng }
          }
        ]
      };
    },()=>{
		
		  navigator.geolocation.getCurrentPosition(function(position) {
		 self.setState({ markers: [
        {
          
          position: { lat:lat, lng:lng }
        } ]});
		  });
		
	});
        
    }
		myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}
handlEditbuilding(){
	  this.setState({editbuilding: 1});
}
OnclickSavebuilding= (event) => {
	  this.setState({editbuilding: 0});
}
	render(){
		
	 
	 return(
	 <div>


		 <Mapautocomplete parentCallback={this.handleCallback}/>
 <br/>
 <div style={{ height: '415px', width: '100%',position:'relative' }}>
 {(this.state.latitude==='' ) &&(
  <h4>Loading...</h4>
 )}
 {(this.state.latitude!=='' ) &&(
        <Map
          google={this.props.google}
          zoom={this.state.zoom}  onClick={this.onClick}
          style={mapStyles} onLoad={this.Getgooglemap}
		   defaultCenter={{lat: this.state.latitude, lng:  this.state.longitude}}
          initialCenter={{
            lat: this.state.latitude,
            lng: this.state.longitude
          }}
        >
		
		
		 {this.state.markers.map((marker, index) => (
            <Marker
              key={index}
              title={marker.title}
              name={marker.name}
              position={marker.position}
            />
          ))}
        
		
        </Map>)}
		
		
</div><br/>
{this.state.or_address !=="" && (<React.Fragment>

	{this.state.editbuilding===1 && (<React.Fragment>
	<p> <TextField id="buildingno" name="buildingno"  variant="outlined"  placeholder="Building No./Building Name/Street"
            fullWidth inputProps={{maxLength:200,  }} className="signinpt"
			value={this.state.buildingno}  onChange={this.myChangeHandler}/> 
			</p>
			<p><Button
            type="submit"
            halfWidth
			
            variant="contained"   
           className="btnmainbg"
           id="btnLogin" 
		onClick={this.OnclickSavebuilding}
           
          >
           Save
          </Button></p></React.Fragment>
	)}
 <h4><b>Address:</b> {this.state.buildingno} {this.state.or_address} <EditLocationAltIcon  onClick={() => {
               this.handlEditbuilding();
              }}/></h4>
			  
 <p className="validate">Note:Your Location will be considered as per the map selection, any building number or name can be change if required</p>
 </React.Fragment>
)}
{this.state.errorpen===true && (
	<Collapse in={this.state.errorpen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handlecloseError();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse>
)}
	 <p className="aligncenter"> <Button
            type="submit"
            fullWidth
			disabled={this.state.btndisabled}
            variant="contained" 
           className="btnmainbg"
           id="btnLogin"  endIcon={<MyLocation/>}
		onClick={this.Onclicklocationsave}
           
          >
      Use My Location 
          </Button></p>
	
	{this.state.addrsdata.length!==0 && (
	<React.Fragment><h3>My Address</h3>
	<ul className='myslocationlist'>
	 {this.state.addrsdata.map((row,i) => {
		  return (
 
<li onClick={()=>{this.Onclickgetlocation(row.ad_latitude,row.ad_longitude,row.ad_buildingdetails,row.ad_address,row.ad_id)}}> <LocationOnIcon className='iconvertical' /> {row.adress}</li>
	 )})}		 
	</ul> </React.Fragment>
	)}
	 </div> 	
	 
 )
   
	 }
}export default GoogleApiWrapper({
  apiKey: 'AIzaSyC8h_mvGDzcKMbco8ouhimrHCXQEQpc--M'
})(Location);





